import React from 'react';
import { X, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ModalShell from '../shared/ModalShell';
import { formatLocalDate } from '../../utils/localDate';

const DAY_LABELS = {
 0: 'Today',
 1: 'Tomorrow (1 day)',
 2: '2 days away',
 3: '3 days away',
 4: '4 days away',
 5: '5 days away',
};

const formatEventDate = (dateString) => formatLocalDate(dateString);

const EventReminderModal = ({ isOpen, onClose, bookingsByDays, formatDate }) => {
 const navigate = useNavigate();
 const format = typeof formatDate === 'function' ? formatDate : formatEventDate;

 const totalCount = Object.values(bookingsByDays || {}).flat().length;
 const open = Boolean(isOpen && totalCount > 0);

 const handleViewBookings = () => {
 onClose();
 navigate('/vendor/bookings');
 };

 return (
 <ModalShell
 isOpen={open}
 onClose={onClose}
 labelledBy="event-reminder-title"
 panelClassName="max-w-lg"
 >
 <div className="bg-surface rounded-lg shadow-sm max-w-lg w-full border border-border overflow-hidden">
 <div className="p-6">
 <div className="flex items-start justify-between gap-4 mb-4">
 <div className="flex items-center gap-3">
 <div className="flex-shrink-0 w-12 h-12 bg-surface-muted border border-border rounded-xl flex items-center justify-center">
 <Calendar className="w-6 h-6 text-ink" />
 </div>
 <div>
 <span className="inline-block px-2.5 py-0.5 bg-surface-muted text-ink text-xs font-medium rounded-full mb-1">
 Event Reminder
 </span>
 <h3 id="event-reminder-title" className="text-lg font-semibold text-ink">
 {totalCount === 1
 ? '1 upcoming event in the next 5 days'
 : `${totalCount} upcoming events in the next 5 days`}
 </h3>
 </div>
 </div>
 <button
 type="button"
 onClick={onClose}
 className="p-2 text-gray-400 hover:text-gray-600 hover:bg-surface-muted rounded-xl transition-colors"
 aria-label="Close"
 >
 <X className="w-5 h-5" />
 </button>
 </div>
 <div className="border-t border-border pt-4">
 <p className="text-sm text-ink-secondary mb-4">
 Bookings scheduled from today through the next 5 days:
 </p>
 <div className="space-y-4 max-h-64 overflow-y-auto">
 {[5, 4, 3, 2, 1, 0].map((days) => {
 const bookings = bookingsByDays[days] || [];
 if (bookings.length === 0) return null;
 return (
 <div key={days} className="space-y-2">
 <div className="flex items-center gap-2">
 <span className="text-xs font-semibold text-ink uppercase tracking-wide">
 {DAY_LABELS[days]}
 </span>
 {bookings[0]?.event_date && (
 <span className="text-xs text-ink-tertiary">
 ({format(bookings[0].event_date)})
 </span>
 )}
 </div>
 <ul className="space-y-1.5">
 {bookings.map((booking) => (
 <li
 key={booking.id}
 className="flex items-center justify-between p-2 bg-surface-muted border border-border rounded-xl text-sm hover:border-border transition-colors"
 >
 <div>
 <span className="font-medium text-ink">
 {booking.booking_reference || `#${booking.id?.substring(0, 8)}`}
 </span>
 {booking.client?.name && (
 <span className="text-ink-secondary ml-2">
 – {booking.client.name}
 </span>
 )}
 </div>
 <button
 type="button"
 onClick={() => {
 onClose();
 navigate(`/vendor/bookings/${booking.id}`);
 }}
 className="text-ink hover:text-ink font-medium text-xs"
 >
 View
 </button>
 </li>
 ))}
 </ul>
 </div>
 );
 })}
 </div>
 </div>
 <div className="mt-6 flex justify-end gap-2">
 <button
 type="button"
 onClick={onClose}
 className="px-4 py-1.5 text-xs font-medium text-ink bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
 >
 Dismiss
 </button>
 <button
 type="button"
 onClick={handleViewBookings}
 className="px-4 py-1.5 text-xs font-medium text-white bg-ink hover:bg-black rounded-md transition-colors shadow-sm"
 >
 View All Bookings
 </button>
 </div>
 </div>
 </div>
 </ModalShell>
 );
};

export default EventReminderModal;
